import Vue from 'vue';
import Vuex from 'vuex';
import getters from './getters';
import user from './modules/user';
import tracking from './modules/tracking';
import crm from './modules/crm';
import map from './modules/map';
import billing from './modules/billing';
import notification from './modules/notification';
import applog from './modules/applog';
import crmBitrix from './modules/crm-bitrix';
import monitor from './modules/monitor';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    user,
    tracking,
    crm,
    map,
    billing,
    notification,
    applog,
    crmBitrix,
    monitor
  },
  getters
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js